import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { MobileContext } from '../Context';
import Slider from './Slider';
import { MeasuredContainer, measuredDefaultSize, MeasuredCookieType, ScreenSizeContext, } from '../Measured';
import { getSliderConfiguration } from './helpers';
import { BREAKPOINTS as breakpoints } from './constants';
var MeasuredSlider = function (_a) {
    var children = _a.children, renderSliderItems = _a.renderSliderItems, restProps = __rest(_a, ["children", "renderSliderItems"]);
    var screenWidth = useContext(ScreenSizeContext);
    var isMobile = useContext(MobileContext);
    return (React.createElement(MeasuredContainer, { cookieType: MeasuredCookieType.SLIDER, cookieDim: 'width', defaultSize: measuredDefaultSize, listenOnWindow: true, limitToParentWidth: true }, function (measuredProps) {
        var containerWidth = measuredProps.container && measuredProps.container.width;
        var _a = getSliderConfiguration({
            breakpoints: breakpoints,
            screenWidth: screenWidth,
            containerWidth: containerWidth,
            dontScale: isMobile,
        }), elementWidth = _a.elementWidth, elementHeight = _a.elementHeight;
        return (React.createElement(Slider, __assign({}, restProps), renderSliderItems({
            width: elementWidth,
            height: elementHeight,
        })));
    }));
};
MeasuredSlider.displayName = 'MeasuredSlider';
export default MeasuredSlider;
//# sourceMappingURL=MeasuredSlider.js.map